import {
  initialState,
  Actions,
  State,
  UPDATE_GROUP,
  UPDATE_GROUP_SUCCESS,
  UPDATE_GROUP_ERROR,
  RESET_UPDATE_GROUP,
} from "../../types/group/update-group";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case UPDATE_GROUP:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case UPDATE_GROUP_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case UPDATE_GROUP_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_UPDATE_GROUP:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
